var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caption grey--text text--lighten-3 text-center"},[_vm._v(" © Kahu Limited | "+_vm._s(_vm.versionName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }